<template>
  <div class="topup-back">
    <div class="text">
      <h1>Przyjęliśmy transakcję do&nbsp;realizacji!</h1>
      <p>Twoje konto zostanie zasilone w&nbsp;ciągu kilku&nbsp;minut.</p>
      <p>Dziękujemy, że jesteś z nami!</p>
    </div>
    <div class="button" v-if="!backUrl">
      <button id="topup-again" type="button" @click="goToTopup">Doładuj ponownie</button>
    </div>
    <div class="button" v-if="backUrl">
      <button type="button" @click="goBack">Dalej</button>
    </div>
    <div class="banner">
      <a href="https://wrodzinie.com.pl/oferta" target="_blank" rel="noreferrer"></a>
    </div>
  </div>
</template>

<script>
import TopupBackMixin from '../../common/mixins/views/TopupBack.mixin'

export default {
  name: 'TopupBack',
  mixins: [TopupBackMixin]
}
</script>

<style src="../assets/scss/back.scss" lang="scss"></style>
